<template>
  <div class="wrapper">
    <div class="content info-text error-message">
      {{messages.errorGeneralMessage}}
      <v-btn
        :ripple="false"
        class="submit back"
        text
        @click="backToStart"
        ref="backToStartRef"
      >{{messages.backToStartPageButtonText}}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'ErrorPage',
  computed: {
    ...mapState([
      'messages'
    ])
  },
  methods: {
    backToStart () {
      this.$router.push({
        name: 'booking'
      })
    },
    // Set focus to first interactive element
    setfocus (data) {
      if (this.$route.name === '404') {
        this.$nextTick(() => { this.$refs.backToStartRef.$el.focus() })
      }
    }
  },
  created () {
    // Event Bus: receive route name to set focus to first interactive element
    eventHub.$on('focusFirstEvent', (payload) => { this.setfocus(payload) })
  }
}
</script>

<style lang="scss">

.wrapper {
  /*border: 2px solid;
  border-color: var(--primary-border-color) !important;*/
  background-color: var(--wrapper-bg-color-primary) !important;
}
</style>
